<div class="password-policy-hints" [class.password-policy-hints--stack]="layout === 'stack'">
    <p class="password-policy-hints__title">Include</p>
    <div class="password-policy-hints__grid">
        <div class="password-policy-hints__item"
            *ngFor="let rule of rules"
            [class.password-policy-hints__item--full]="rule.fullWidth"
            [class.password-policy-hints__item--met]="rule.met">
            <span class="password-policy-hints__icon-wrap" aria-hidden="true">
                <svg class="password-policy-hints__tick" viewBox="0 0 12 12">
                    <path d="M2.5 6.2L4.8 8.5L9.5 3.5" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </span>
            <span class="password-policy-hints__label">
                <span class="password-policy-hints__condition">{{ rule.name }}</span>
                <span class="password-policy-hints__range">({{ rule.hint }})</span>
            </span>
        </div>
    </div>
</div>
